import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicComponentType } from '../../../shared/enums/basic-component-type.enums';

@Component({
  selector: 'hdi-toggle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class ToggleComponent {
  @Input() label?: string;
  @Input() active: boolean = false;
  @Input() disabled: boolean = false;
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggle(): void {
    if (!this.disabled) {
      this.active = !this.active;
      this.checkedChange.emit(this.active);
    }
  }
  protected readonly ToggleType = BasicComponentType;
}
